<template>
  <main class="LayoutPublic layout layout-public" :class="{ 'layout-login': isLoginPage }">
    <div class="layout-side" v-if="isLoginPage">
      <div>
        <h1>Capital Flow Tech</h1>

        <p class="tagline">Algorithmic Trading Technology for Digital Assets</p>

        <p>Secure access to account statements, software deployment information and operational notices for CFT software services.</p>

        <p>Client-controlled accounts. Restricted API deployment. No custody. No withdrawal authority.</p>
      </div>
    </div>
    <div class="layout-side" v-else />

    <div class="layout-main">
      <div class="layout-view">
        <router-view />
      </div>
    </div>
  </main>
</template>

<script>
  export default {
    computed: {
      isLoginPage() {
        return this.$route.name === 'auth-login'
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import '@/sass/styles.vars.all'

  .LayoutPublic
    display: flex
    overflow: hidden
    min-height: 100vh
    background-color: #f4efe3
    background-image: repeating-radial-gradient(circle at 50% 44%, transparent 0 47px, rgba(20, 38, 79, .014) 47px 48px), radial-gradient(circle at 50% 42%, #faf7f0 0%, #f3ede1 56%, #ebe3d2 100%)

  .layout-side
    position: relative
    overflow: hidden
    padding: $spacer-5
    flex: 1
    background: transparent
    border-right: 1px solid rgba(#c2a15f, .22)
    display: none

    @include media-breakpoint-up(lg)
      display: flex

    // Large translucent CF monogram watermark (reuses existing lightweight logo asset)
    &:before
      content: ''
      position: absolute
      top: 50%
      left: 50%
      width: 620px
      height: 402px
      transform: translate(-50%, -50%)
      background: url('/img/capital-flow-tech-logo.svg') center center no-repeat
      background-size: contain
      opacity: .05
      pointer-events: none

  .layout-main
    padding: $spacer-5
    flex: 2
    overflow: auto
    display: flex
    justify-content: center
    align-items: center

    .layout-login &
      flex: 1

  .layout-view
    width: 100%

    .layout-narrow
      max-width: 500px

    .layout-large
      max-width: 750px

  .layout-side
    flex-direction: column
    align-items: center
    justify-content: center

    div
      position: relative
      z-index: 1
      color: #4a5568
      max-width: 380px

      p
        line-height: 1.6

    h1
      color: #14264f
      text-transform: uppercase
      font-weight: 600
      letter-spacing: .05em
      font-size: 1.55em

      &:after
        content: ''
        display: block
        width: 3em
        height: 2px
        margin: .8em 0 1.1em
        background: #c2a15f

    .tagline
      color: #1f2f52
      text-transform: uppercase
      letter-spacing: .08em
      font-size: .82rem
      font-weight: 600
      line-height: 1.6
      margin-bottom: 1.6em
</style>
